import { fiasLevelToVisibilityKey, IAddress, IAddressVisibility } from '@interfaces/address.interface';

/**
 * Функция получения строкового представления для структуры IAddress
 */
export const getStringPresentation = (address: IAddress, visibility: IAddressVisibility | null): string => {
    if (!address || typeof address !== 'object') {
        return '';
    }

    // если видимость частей адреса не задана, используем старую логику - берём fullname
    if (visibility === null) {
        return [address.postalcode, address.fullname, address.additional_information].filter((x) => !!x).join(', ');
    }

    // вычисляем видимость частей адреса по новой логике
    const parts: string[] = [];

    // почтовый индекс
    if (visibility.is_index) {
        parts.push(address.postalcode);
    }

    // части, относящиеся к тому или иному уровню ФИАС
    // служба ФИАС исторически их сохраняет в обратном порядке,
    // но где-то в коде фронтенда какой-то нехороший человек иногда их сохраняет в прямом
    // убедимся, что они идут по возрастанию уровней
    if (Array.isArray(address.parents)) {
        const parents = [...address.parents].sort((a, b) => a.level - b.level);
        for (const parent of parents) {
            const key = fiasLevelToVisibilityKey(parent.level);
            if (key !== null && visibility[key]) {
                parts.push(parent.formalname);
            }
        }
    } else {
        parts.push(address.fullname);
    }

    // дополнительная информация
    if (visibility.is_landmark) {
        parts.push(address.additional_information);
    }

    return parts.filter((x) => !!x).join(', ');
};
